// extracted by mini-css-extract-plugin
export default {"footerSection":"footer_footerSection__OxEnJ","footerLink":"footer_footerLink__fkJtX","footer":"footer_footer__d7y5C","copyRightText":"footer_copyRightText__kTRSB"};